import api from './api';

const addressFilterService = {
  // Verfügbare Filter-Felder und Operatoren abrufen
  getFields: async () => {
    const response = await api.get('/address-filters/fields');
    return response.data;
  },

  // Alle gespeicherten Filter abrufen
  getAll: async () => {
    const response = await api.get('/address-filters');
    return response.data;
  },

  // Neuen Filter erstellen
  create: async (filterData) => {
    const response = await api.post('/address-filters', filterData);
    return response.data;
  },

  // Filter aktualisieren
  update: async (filterId, filterData) => {
    const response = await api.put(`/address-filters/${filterId}`, filterData);
    return response.data;
  },

  // Filter löschen
  delete: async (filterId) => {
    const response = await api.delete(`/address-filters/${filterId}`);
    return response.data;
  },

  // Filter-Vorschau (ohne Speichern)
  preview: async (conditions, logic = 'AND') => {
    const response = await api.post('/address-filters/preview', { conditions, logic });
    return response.data;
  },

  // Filter anwenden und Ergebnisse abrufen
  apply: async (filterId, skip = 0, limit = 100) => {
    const response = await api.get(`/address-filters/${filterId}/apply`, {
      params: { skip, limit }
    });
    return response.data;
  },

  // Ad-hoc Filter anwenden und Adressen abrufen (ohne Speichern)
  applyAdhoc: async (conditions, logic = 'AND', { limit = 2000, includeDetails = false } = {}) => {
    const response = await api.post('/address-filters/apply-adhoc', { conditions, logic }, {
      params: { limit, include_details: includeDetails }
    });
    return response.data;
  },

  // E-Mail-Empfänger eines gespeicherten Filters (für den E-Mail-Composer)
  emails: async (filterId) => {
    const response = await api.get(`/address-filters/${filterId}/emails`);
    return response.data;
  },

  // Filter-Ergebnisse exportieren
  export: async (filterId, format = 'csv') => {
    const response = await api.post(`/address-filters/${filterId}/export`, null, {
      params: { format },
      responseType: 'blob'
    });
    return response.data;
  },
};

export default addressFilterService;
